// extracted by mini-css-extract-plugin
module.exports = {"root":"_5cbf1a","topContent":"_0cbac4","iconCont":"_27c885","index":"_a96c37","title":"_a4c739"};